import React from "react";
import Button from "@components/common/Button"
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

export default ({ activescenarioindex, setScenario , trendpercent, autopercent}) => {
  const { t } = useTranslation()
  
  return (
  <div className={styles.buttonGroup}>
    <Button
      type={activescenarioindex === 1 && "primary"}
      onClick={setScenario(0, 1)}
    >
      {t("scenarios.WithoutChange")}
    </Button>

    <Button
      type={activescenarioindex === 2 && "primary"}
      onClick={setScenario(trendpercent, 2)}
    >
      {t("scenarios.CurrentTrend")}
    </Button>

    <Button
      type={activescenarioindex === 3 && "primary"}
      onClick={setScenario(autopercent, 3)}
    >
      {t("scenarios.StayWithinBudget")}
    </Button>
  </div>
  )
}